import React, { Fragment } from "react";
import Header from "./Header";

import Meet from "./Meet";
import Meet2 from "./Meet2";
import daniel from "../Assets/daniel_portrait.jpeg";
import jack from "../Assets/jack_portrait.jpg";
import matt from "../Assets/matt_portrait.jpg";
import kendall from "../Assets/kendall_portrait.jpg";
import FadeInOnScroll from "./UI/FadeInOnScroll";
const Team = () => {
  const daniel_about =
    "Daniel Rosenthal is from Yardley, PA. He is a senior at Wake Forest and is majoring in engineering with a concentration in electrical & computer engineering and is minoring in computer science and math. Daniel grew up playing disc golf at summer camp.";
  const jack_about =
    "Jack Connelly is from Redondo Beach, CA. He is a Senior at Wake Forest University and majors in Engineering with a concentration in electrical and computer engineering. Jack is also minoring in computer science and mathematics. Jack first played disc golf at the age of 10.";
  const matt_about =
    "Matt Martin hails from the New England area, growing up in Wilton, CT. He is majoring in engineering with a concentration in civil & environmental engineering and is minoring in math. He picked up disc golf to play with his family, and saw this project as an opportunity to become more involved with the sport. He is an avid golfer and believes that the technology in that sport needs to be introduced to the disc golf community. Matt first played disc golf at the age of 11.";
  const kendall_about =
    "Kendall Scott is from Wilmington, NC. He is a senior engineering major at Wake Forest University. With a history of working in the sports & outdoor industry, he believes in the advancement of disc golf technology to grow the game. Kendall played his first round of disc golf at the age of 8.";

  return (
    <Fragment>
      <Header intro="Meet the Team"></Header>
      <div>
        <FadeInOnScroll>
        <Meet photo={daniel} about={daniel_about}></Meet>

        </FadeInOnScroll>
        <FadeInOnScroll>
        <Meet2 photo={jack} about={jack_about}></Meet2>

        </FadeInOnScroll>
        <FadeInOnScroll>
        <Meet photo={matt} about={matt_about}></Meet>

        </FadeInOnScroll>
        <FadeInOnScroll>
        <Meet2 photo={kendall} about={kendall_about}></Meet2>

        </FadeInOnScroll>
      </div>
    </Fragment>
  );
};

export default Team;
